import React from "react";
import ConfirmActionModal from "./ConfirmActionModal";

interface DeleteConfirmModalProps {
  visible: boolean;
  onCancel: () => void;
  onOk: () => Promise<void>;
  confirmText: string;
  setConfirmText: (text: string) => void;
  requiredConfirmText: string;
}

const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = (props) => {
  const warningItems = [
    "删除项目后，所有相关数据将被永久删除",
    "删除后无法恢复",
    "相关的API密钥将立即失效",
  ];

  return (
    <ConfirmActionModal
      {...props}
      title="删除项目确认"
      okText="确认删除"
      warningItems={warningItems}
      icon={
        <i
          className="ri-delete-bin-5-line"
          style={{ fontSize: 22, color: "#ff4d4f", marginRight: 12 }}
        />
      }
    />
  );
};

export default DeleteConfirmModal;
